/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {Delete} from "@mui/icons-material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import Formulario_Variacion from "../Formularios/Formulario_Variacion";
import {subirMultiplesImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirMultiplesImagenHostingFile";

const Dialogo_Variaciones = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()

        iniciarCarga()


        let variaciones = entidad.variaciones
        if (variaciones) {

            let imgs = variaciones.map((it) => {
                    if (it.img) {
                        return it.img
                    } else {
                        return ''
                    }
                }
            )
            if (imgs) {

                let doxImgVariantes = await subirMultiplesImagenHostingFile(imgs)
                if (doxImgVariantes.res) {
                    imgs = doxImgVariantes.data
                }

                for (let i = 0; i < imgs.length; i++) {
                    variaciones[i].img = imgs[i]
                }

                entidad.variaciones = variaciones
            }


        } else {
            entidad.variaciones = []
        }


        let dox = await guardarDoc('productos', entidad)
        if (dox.res) {
            await guardarFecha()
            terminar({aviso: 'Datos de producto subidos'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }


    const borrar = async () => {
        await borrarDoc('productos', datos.id)
        terminar({aviso: 'Registro borrado'})
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Variacion props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Variaciones